import React, { useContext, useEffect, useState } from 'react';
import { FormControl, FormLabel, SelectChangeEvent, TextField } from '@mui/material';
import CartContext from '../../../../contexts/CartContext';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import ProvinceSelector from './ProvinceSelector';
import IfFalse from '../../../conditions/IfFalse';

type Props = {
  ignoreShippingMethod?: boolean,
  ignoreAddress?: boolean
}

const DeliveryAddress = ({ ignoreAddress, ignoreShippingMethod }: Props) => {

  // Get the cart from the context
  const {cart, setCartState} = useContext(CartContext);

  const [override, setOverride] = useState<DeliveryAddress>(cart.deliveryAddress);

  // Pre-set the name, but only do this once
  useEffect(() => {
    const newCartState = {
      ...cart,
      deliveryAddress: {
        ...cart.deliveryAddress,
        firstName: cart.deliveryAddress.firstName ? cart.deliveryAddress.firstName : cart.customerAddress.firstName,
        lastName: cart.deliveryAddress.lastName ? cart.deliveryAddress.lastName : cart.customerAddress.lastName
      }};
    setCartState(newCartState);
    
    setOverride(newCartState.deliveryAddress);
  }, []);
  
  // Every field edit syncs to BOTH local input state AND the cart. The previous
  // pattern only synced cart on blur (or postal-length-complete), which left
  // browser autofill stranded — autofill never fires blur, so the cart stayed
  // empty and the shipping API got nothing to work with.
  const updateDeliveryAddressField = (name: string, value: string) => {
    const next = { ...override, [name]: value };
    setOverride(next);
    setCartState({
      ...cart,
      deliveryAddress: next,
    });
  }

  const onFirstNameChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateDeliveryAddressField('firstName', event.target.value);
  }

  const onLastNameChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateDeliveryAddressField('lastName', event.target.value);
  }

  const onStreetChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateDeliveryAddressField('street', event.target.value);
  }

  const onAdditionalChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateDeliveryAddressField('additional', event.target.value);
  }

  const onCityChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateDeliveryAddressField('city', event.target.value as string);
  }

  const onProvinceChanged = (value: string) => {
    updateDeliveryAddressField('province', value);
  };

  const onPostalChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateDeliveryAddressField('postal', event.target.value.toUpperCase());
  }


  if (!ignoreShippingMethod && cart.shippingMethod === 'PICKUP') {
    return (
      <>
      </>
    );
  }

  return (
    <Card>
      <CardContent>
        <FormControl component="fieldset">
          <FormLabel component="legend" className='checkout-form-legend'>Delivery details</FormLabel>
            <div className='checkout-form-fields'>
              <IfFalse condition={ignoreShippingMethod}>
                <TextField required id="firstName" label="First Name" value={override.firstName} onChange={onFirstNameChanged}/>
                <TextField required id="lastName" label="Last Name" value={override.lastName} onChange={onLastNameChanged}/>
              </IfFalse>
              <IfFalse condition={ignoreAddress}>
                <TextField required id="street" label="Street Address" value={override.street} onChange={onStreetChanged}/>
                {/* <TextField id="additional" label="Additional" value={override.additional} onChange={onAdditionalChanged}/> */}
                <TextField required id="city" label="City" value={override.city} onChange={onCityChanged}/>
                <ProvinceSelector
                  province={override.province}
                  onChange={onProvinceChanged}
                  />
              </IfFalse>
              <FormControl>
                <TextField
                  label="Postal Code"
                  value={override.postal}
                  onChange={onPostalChanged}
                  name="postal"
                  id="postal"
                />
              </FormControl>
            </div>
          </FormControl>
      </CardContent>
    </Card>
  )
}

export default DeliveryAddress;
